import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[anomalyGrid]'
})
export class AnomalyGridDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
